export const zendeskKey = "700b970d-8185-499b-8dd2-20eb09e7e411"

export const loadZendeskScript = (): void => {
  if (window.zE && typeof window.zE === "function") {
    window.zE("messenger", "open")
    return
  }
  const zendeskScript = document.createElement("script")
  zendeskScript.id = "ze-snippet"
  zendeskScript.defer = true
  zendeskScript.async = true
  zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`
  zendeskScript.onload = () => {
    let attempt = 0
    // stop the interval after 20s if the script fails to load
    const maxAttempt = 80
    const intervalTimer = setInterval(() => {
      attempt += 1
      if (attempt >= maxAttempt) clearInterval(intervalTimer)
      if (typeof window.zE === "function") {
        window.zE("messenger", "open")
        const button = document.getElementById("zendesk-cta")
        button?.style.setProperty("display", "none", "important")

        // zendesk chat icon no longer has an id, so we need to find it by title
        const launcher = document.querySelector(
          '[title*="Button to launch messaging window"]'
        ) as HTMLElement

        if (launcher) {
          clearInterval(intervalTimer)
          if (launcher.parentNode)
            (launcher.parentNode as HTMLElement).id = "zendesk-launcher"
          addZendeskEvents()
        }
      }
    }, 250)
  }
  document.head.appendChild(zendeskScript)
}

const addZendeskEvents = () => {
  const badgeContainer = document.getElementById("zendesk-message-badge")
  const badge = document.getElementById("zendesk-message-badge-text")
  const button = document.getElementById("zendesk-cta")
  const launcher = document.getElementById("zendesk-launcher")

  const populateUnreadIndicator = (count) => {
    if (!count) return resetUnreadIndicator()
    badgeContainer?.style.setProperty("display", "block")
    if (badge) badge.innerHTML = `${count}`
  }

  const resetUnreadIndicator = () => {
    badgeContainer?.style.setProperty("display", "none")
    if (badge) badge.innerHTML = "0"
  }

  window.zE("messenger:on", "open", () => {
    button?.style.setProperty("display", "none", "important")
    launcher?.style.setProperty("display", "block", "important")
    resetUnreadIndicator()
  })

  window.zE("messenger:on", "close", () => {
    button?.style.setProperty("display", "block", "important")
    launcher?.style.setProperty("display", "none", "important")
  })

  window.zE("messenger:on", "unreadMessages", (count) => {
    populateUnreadIndicator(count)
  })

  resetUnreadIndicator()
}
